"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _moment = _interopRequireDefault(require("moment/moment"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone/moment-timezone"));

var _BasicColumn = _interopRequireDefault(require("./BasicColumn"));

var _localization = require("../../../../toolkit/localization");

//
//  src/data/table/DatetimeColumn.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 12/31/18.
//  Copyright © 2018-present ContextLogic Inc. All rights reserved.
//

/* External Libraries */

/* Relative Imports */
var DatetimeColumn = (0, _mobxReact.observer)(function (props) {
  var format = props.format,
      timezone = props.timezone,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["format", "timezone"]);

  var _useLocalization = (0, _localization.useLocalization)(),
      _useLocalization$curr = _useLocalization.currentLocale4Letter,
      currentLocale4Letter = _useLocalization$curr === void 0 ? "EN-US" : _useLocalization$curr;

  return /*#__PURE__*/_react["default"].createElement(_BasicColumn["default"], otherProps, function (_ref) {
    var value = _ref.value;

    if (timezone) {
      return _momentTimezone["default"].unix(value).tz(timezone).locale(currentLocale4Letter).format(format);
    }

    return _moment["default"].unix(value).locale(currentLocale4Letter).format(format);
  });
});
var _default = DatetimeColumn;
exports["default"] = _default;